import React, { useContext, useState } from 'react';
import VideoCallWindow from './VideoCallWindow';
import BuildingsView from './Building/BuildingsView';
import DevicesView from './DevicesView';
import { ACSContext } from '../contexts/ACSContext'; 
import Header from './Layout/Header';
import { Grid2 } from '@mui/material';
import { useTranslation } from 'react-i18next';
import WelcomePopup from './WelcomePopup';

export default function Dashboard () {
  const { activeCall, incomingCall } = useContext(ACSContext);
  const isCallActive = activeCall || incomingCall;
  const { t, i18n } = useTranslation(); //for localisation
  const [showPopup, setShowPopup] = useState(true); // Show popup on first load

  if (showPopup) {
    return <WelcomePopup open={showPopup} onClose={() => setShowPopup(false)} />;
  }
  
  const getDirection = (lang) => {
    // Add more languages as needed
    const rtlLanguages = ['ar', 'he', 'fa'];
    return rtlLanguages.includes(lang) ? 'rtl' : 'ltr';
  };  

  return (
    <div dir={getDirection(i18n.language)}>
      <Header />
        <Grid2 container spacing={2} justifyContent="space-evenly">
          <Grid2 xs={12} sm={6}>
            {isCallActive?
              <VideoCallWindow />
              :
              <BuildingsView/>
            }
          </Grid2>
          <Grid2 xs={12} sm={6}>
              <DevicesView />
          </Grid2>
        </Grid2>
            
    </div>
  );
};
